import { render } from "./HomeLabel.vue?vue&type=template&id=7eff8e72&scoped=true"
import script from "./HomeLabel.vue?vue&type=script&lang=js"
export * from "./HomeLabel.vue?vue&type=script&lang=js"

import "./HomeLabel.vue?vue&type=style&index=0&id=7eff8e72&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eff8e72"]])

export default __exports__